
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g9e6AQMi4SzwinkC_AqyRBzbcRyOXWwMznzfjn2JLxnsMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexBwj5RDS6T0_T47zTNB_X5y01nDyCBPyzOn0i_gJ67s4Meta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6BRwxyfk9H_45hKmm49GPXv27fSH45BNTo_45i8_zuLD37cMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexdH4uq_45m4N5KC_wD1Bstdf81nIm_45pkstIFlb3KZy3YuUMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93e_VZWEtqqV3_GTykz1M5eqEh1jU68ii1V69kebuKKbsMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexZqP8evX6GF71_45cubS4jiepxQNEsK6FzByiRnCNSOdYIMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93sGtquKduieovCvMkQ9KZyoxshK8gMqUHcWBY0hhACZcMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexXCDTRKVF7r1mCYZUT1MhSpVwiymm6c_45IJ8vGOxLjfX8Meta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93CoQM7DMv8WN9zE0DSvTFgr5MocxiFiynaskFDH33DWQMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexHdaBM3nync4VsYSpN2tXMYs8UcXteeztwBbdJcAIdKwMeta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexoegIE64sG1snFCereuBXclW1OAmXkJzZJCFbpsiv3I8Meta } from "/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexZqP8evX6GF71_45cubS4jiepxQNEsK6FzByiRnCNSOdYIMeta || {},
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexXCDTRKVF7r1mCYZUT1MhSpVwiymm6c_45IJ8vGOxLjfX8Meta || {},
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexHdaBM3nync4VsYSpN2tXMYs8UcXteeztwBbdJcAIdKwMeta || {},
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexoegIE64sG1snFCereuBXclW1OAmXkJzZJCFbpsiv3I8Meta || {},
    component: () => import("/codebuild/output/src49631701/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]